/**
 *  jsbridge的最基层库，提供底层的接口
 *
 *  @module jsbridge/jsbridge_base
 */
import Env from 'common/env.js';
import Dom from '../base/mdom.js';
import _qualityBase from '../quality/quality_report_base.js';
import Queue from '../base/queue.js';
import JsapiLog from './jsapi_log.js';
import { beforeInvoke } from './jsbridge_hook';
let exportData;
if(!Env.isCSR){

    (function (win, doc) {
        var wxBridge;

        if ( win['WXGAME'] && win['WXGAME'].WxBridge ) {
            wxBridge = win['WXGAME'].WxBridge;
            exportData = wxBridge;
            return;
        }

        //这里是 只能是 Dom.window,不能只能用 win
        var _isWechat = Dom.window.navigator.userAgent.indexOf('MicroMessenger/') != -1;
        var _isAndroid = /(Android)/i.test(Dom.window.navigator.userAgent);
        var _verifyObj = {};

        /**
         * 声明verify队列。 一定要是全局的。只为解决iframe的问题。
         */
        Dom.window.jsapiQueue = Dom.window.jsapiQueue || new Queue();
        /**
         * 使用同步队列。
         */
        Dom.window.jsapiQueue.setSync();

        Dom.window.verifiedMap = {};
        /**
         *  常用的apis delete 已不需要verify 'getGameData', 'setGameData'
         *  @static
         *  @name apis
         */
        var apis = [
            'hideMenuItems', 'showMenuItems', 'cache', 'setPageTitle',
            'downloadAppInternal','launchApplication', 'addDownloadTaskStraight',
            'clearBounceBackground', 'disableBounceScroll', 'dispatchEvent',
            'openGameWebView',
            'openCustomWebview', //Android 6.5.0
            'openWKWebView',     //iOS 6.3.13
            'recordOperateUserData', // 个人隐私上报
            'pauseDownloadTask', 'resumeDownloadTask',
            'recordHistory', 'getGameCommInfo', 'launchMiniProgram',
            'openGameUrlWithExtraWebView', 'reportGamePageTime', 'currentMpInfo', 
            'getNetworkType', 'showSmileyPanel', 'onGetKeyboardHeight',
            'operateGameCenterMsg','reportGameWeb', 'jumpDownloaderWidget',
            'getDownloadWidgetTaskInfos',
            'openGameCenter',
            'clearGameData',"setNavigationBarButtons","openGameRegion","onNetWorkChange","openWeApp","batchUpdateWepkg",
            "profile", 'enableGameView', 'uploadMediaFile', 'shareCustomContent', 'setGameTab', 'editAddress', 'startGameLifeConversation', 'setScreenOrientation', 'openFinderTopicView', 'gameCenterFacade',
            'configLiveBrandName', 'geoLocation', 'chooseMedia', 'chooseImage', 'openGameTabHome'
        ];
        /** 不需要的菜单选项 */
        var menuItems = [
            'menuItem:share:weiboApp', 'menuItem:share:QZone', 'menuItem:share:qq', 'menuItem:share:facebook',
            'menuItem:openWithQQBrowser', 'menuItem:openWithSafari', 'menuItem:copyUrl',
            'menuItem:share:brand', 'menuItem:share:email', 'menuItem:wework'
        ];
        /*
            开放标签
        */
        var openTags = ['wx-open-video']
        var _onList = {};
        //act = "hideMenuItems"/"showMenuItem"

        var A8KeyStoreKey = 'A8KeyStoreKey';

        function verifyCall(act, opt, cbk) { // preverify近期会去掉这个流程，这里只保留错误的日志

            var WXGAME  = win.WXGAME        || {};
            var qualityBase = WXGAME.baseQualityReport || _qualityBase;
            var verifyCallInstance = qualityBase.StartRunner(
                'jsbridge_base.verifyCall',{act:act},null
            );
            verifyCallInstance.EndLogic({
                err_msg:'jsbridge_base.verifyCall starts'
            });
            var qRun = function(){
                /**
                 * 增加如果某个jsapi被成功verify过，那就不要再verify了
                 */
                var isAllVerified = true;
                act = act || [];
                for(var ia=0,ialen = act.length; ia < ialen; ia++){
                    if( !Dom.window.verifiedMap[act[ia]] ){
                        isAllVerified = false;
                        break;
                    }
                }


                /*总的 开始调用verifyCall数*/

                if( true === isAllVerified ){
                    // 成功场景【删除】
                    // if (window.logInfo) {
                    //     logInfo('verifyCall',act,
                    //         ' has been verified'
                    //     );
                    // }
                    /**
                     * 回调数 isAllVerified 回调数
                     */

                    opt.err_msg = 'preVerifyJSAPI:ok';
                    cbk && cbk(true,opt);
                    return;
                }

                /**
                 * 接下来处理并发调用，相同的 act，
                 * 但被同时调用无数次。
                 */
                Dom.window.jsapiQueue.run(function(vdata){
                    var context = this;


                    /**
                     * 如果是队列第二个及以后 元素的 调用。。
                     */

                    var isNextActInPreAct = true;
                    if( undefined != vdata ){
                        vdata.verifiedList = vdata.verifiedList || [];
                        for(var p = 0,len=act.length; p < len; p++){
                            if( undefined == vdata.verifiedList[act[p]] ){
                                isNextActInPreAct = false;
                                break;
                            }
                        }
                    }


                    if( undefined != vdata && isNextActInPreAct === true ){
                        var lastRes = {};
                        // 对定位问题无帮助+后续prevify流程会移除【删除】
                        // if (window.logInfo) {
                        //     logInfo('verifyCall',vdata,
                        //         ' same act call next times'
                        //     );
                        // }
                        if(vdata.ret == true){
                            opt.res = vdata.res;
                            lastRes = opt;
                        }else{
                            lastRes = vdata.res;
                        }
                        /**
                         * 回调数 isNextActInPreAct 回调数
                         */

                        context.done(vdata);
                        cbk && cbk( vdata.ret, lastRes);

                    }else{
                        /**
                         * 如果是第一次 调用。。
                         */
                        // 对定位问题无帮助+后续prevify流程会移除【删除】
                        // if(window.logInfo){
                        //     logInfo('verifyCall',opt,
                        //         ' start call verifyjsapi by preVerifyJSAPI'
                        //     );
                        // }

                        if(window.ReportLuggage && window.NavigationStart){
                            window.ReportLuggage.previrifyBgn(new Date().getTime() - window.NavigationStart, new Date().getTime(), window.NavigationStart);
                        }

                        invoke('preVerifyJSAPI', {
                            verifyOpenTagList: openTags,
                            verifyJsApiList : act,
                            verifyAppId     : "wx62d9035fd4fd2059",
                            verifyTimestamp : opt.timestamp || win.timestamp,
                            verifyNonceStr  : opt.noncestr  || win.noncestr,
                            verifySignType  : "sha1",
                            verifySignature : opt.signature || win.signature
                        }, function (res) {
                            // 对定位问题无帮助+后续prevify流程会移除【删除】
                            // if(window.logInfo){
                            //     logInfo('verifyCall',res,
                            //         ' call verifyjsapi by preVerifyJSAPI end'
                            //     );
                            // }
                            var lastRes = {};

                            var verifyRes = null;
                            if (res && (res.err_msg || res.errMsg || '').indexOf(':ok') != -1) {
                                verifyRes = true;

                                if(window.ReportLuggage && window.NavigationStart){
                                    window.ReportLuggage.previrify(new Date().getTime() - window.NavigationStart, new Date().getTime(), window.NavigationStart);
                                }
                                if(window.performance && window.performance.timing.navigationStart &&  (!window.WxGamePerformanceParams || !window.WxGamePerformanceParams["WebPreVerifyTime"])){
                                    window.WxGamePerformanceParams = window.WxGamePerformanceParams || {};
                                    window.WxGamePerformanceParams["WebPreVerifyTime"] = new Date().getTime() - window.performance.timing.navigationStart;
                                }

                                act = act || [];
                                for(var i=0,len=act.length;i<len;i++){
                                    Dom.window.verifiedMap[act[i]] = true;
                                }

                                /**
                                 * preVerifyJSAPI:ok 成功数
                                 */

                            } else {

                                verifyCallInstance.EndLogic({
                                    err_msg:'jsbridge_base.verifyCall_fail' + JSON.stringify(res)
                                });
                                verifyRes = false;

                                act = act || [];
                                for(var i=0,len=act.length;i<len;i++){
                                    Dom.window.verifiedMap[act[i]] = false;
                                }
                            }
                            var queueData = {
                                ret         :verifyRes,
                                res         :res,
                                verifiedList:act
                            }

                            if(queueData.ret == true){
                                opt.res = queueData.res;
                                lastRes = opt;
                            }else{
                                lastRes = queueData.res;
                            }
                            /**
                             * 调用 preVerifyJSAPI 函数 的回调数
                             */

                            context.done(queueData);
                            cbk && cbk( queueData.ret, lastRes);
                        });
                    }
                });
            };

            if (!Dom.window.WeixinJSBridge) {
                Dom.window.document.addEventListener('WeixinJSBridgeReady', function () {
                    qRun.call(Dom.window);
                });
                return;
            }
            else{
                qRun.call(Dom.window);
            }

        }

        function getBridge(cbk) {
            var that = this;

            cbk = cbk || function(){};
            if (!Dom.window.WeixinJSBridge) {
                if (window.logInfo) {
                    logInfo('getBridge',
                        ' top window bridge not exists'
                    );
                }
                win.hasNoBridgeTime = (new Date()).getTime();
                cbk.isCalled = false;
                if (_isAndroid) {
                    if (!win.preReadyAdded) {
                        Dom.window.document.addEventListener('WeixinJSBridgePreReady', function () {
                            win.preReadyAdded = true;
                            win.bridgeReadyTime1 = new Date().getTime();
                            if (false == cbk.isCalled) {
                                cbk.call(that, Dom.window.WeixinJSBridge);
                                cbk.isCalled = true;
                            }
                        });
                    }
                }

                if(window.ReportLuggage && window.NavigationStart && !window.reportJsbridgeReadyBgn){
                    window.ReportLuggage.jsbridgeReadyBgn(new Date().getTime() - window.NavigationStart, new Date().getTime(), window.NavigationStart);
                    window.reportJsbridgeReadyBgn = true;
                }

                /* 这里还真是需要，被多次add的可能。不要自作主张，去做逻辑 防止 多次添加 WeixinJSBridgeReady */
                Dom.window.document.addEventListener('WeixinJSBridgeReady', function () {
                    if(window.ReportLuggage && window.NavigationStart && !window.reportJsbridgeReadyEnd){
                        window.ReportLuggage.jsbridgeReadyEnd(new Date().getTime() - window.NavigationStart, new Date().getTime(), window.NavigationStart);
                        window.reportJsbridgeReadyEnd = true;
                    }

                    if(window.performance && window.performance.timing.navigationStart && (!window.WxGamePerformanceParams || !window.WxGamePerformanceParams["JsapiReadyTime"])){
                        window.WxGamePerformanceParams = window.WxGamePerformanceParams || {};
                        window.WxGamePerformanceParams["JsapiReadyTime"] = new Date().getTime() - window.performance.timing.navigationStart;
                    }


                    win.bridgeReadyTime2 = new Date().getTime();
                    if (false == cbk.isCalled) {
                        cbk.call(that, Dom.window.WeixinJSBridge);
                        cbk.isCalled = true;
                    }
                });

            } else {
                // 一个页面周期内只要出现过一次window.WeixinJSBridge，就会一直存在的，所以只要写一次日志即可。做过简单验证，打开9.0首页，只在页面停留操作不超过10s，会打42次log
                if (window.logInfo && !window.hasBridgeTime) {
                    logInfo('getBridge',
                        ' top window bridge already exists'
                    );
                }
                if(window.ReportLuggage && window.NavigationStart && !window.reportJsbridgeReadyBgn){
                    window.ReportLuggage.jsbridgeReadyBgn(new Date().getTime() - window.NavigationStart, new Date().getTime(), window.NavigationStart);
                    window.ReportLuggage.jsbridgeReadyEnd(new Date().getTime() - window.NavigationStart, new Date().getTime(), window.NavigationStart);
                    window.reportJsbridgeReadyBgn = true;
                    window.reportJsbridgeReadyEnd = true;
                }
                window.hasBridgeTime = (new Date()).getTime();
                cbk && cbk.call(that, Dom.window.WeixinJSBridge);
            }
        }
        function log(str){
            (new Image()).src = 'https://game.weixin.qq.com/favicon.ico?log=' + str;
        }

        function addA8keyEvent(cbk){
            !Dom.window.onGetA8KeyUrlOned &&
                Dom.window.WeixinJSBridge &&
                Dom.window.WeixinJSBridge.on('onGetA8KeyUrl', function(res) {
                    if(window.logInfo){
                        logInfo('getUinKey',res,'get Login from Event onGetA8KeyUrl');
                    }
                    if(false === cbk.isCbkCalled){

                        saveLoginedA8key(res);

                        cbk.isCbkCalled = true;
                        cbk && cbk(res, 'a8keyonGetA8KeyUrl');
                    }
                });
            /*
                这个是全局 防止onGetA8KeyUrl 添加 2次
                然后也因为这个只能在全局 执行一次，其实第二次调用到getA8key时，
                cbk 一定是来自 getWePkgAuthResult
            */
        Dom.window.onGetA8KeyUrlOned = true;
        }

        /**
         * 关注这个函数的回调，cbk(jsapiresult,flag)
         *
         * @param {any} cbk
         */
        function getA8key(cbk){

            var WXGAME  = win.WXGAME        || {};
            var qualityBase = WXGAME.baseQualityReport || _qualityBase;
            var getA8keyInstance = qualityBase.StartRunner(
                'jsbridge_base.getA8key',{},null
            );
            /**
             * 定义一个获取 getWePkgAuthResult
             */
            var wepkgResultFailTimes = 0;
            /*
            *   isCbkCalled 这个变量用于控制，
            *   on事件与getWePkgAuthResult两个东东，都将cbk给触发一次
            */
            cbk = cbk  || function(){};
            cbk.isCbkCalled = false;

            /**
             * 注册一下onGetA8KeyUrl 事件。。这个是在调用 getWePkgAuthResult前
             * 就必须得添加好。
             */
            addA8keyEvent(cbk);

            /**
             * 这里有一个尝试重试逻辑。可以预见的这里有一个  不可预见的问题。
             * 比如并发同时调用此接口 getA8key 100并发的。
             * 其中如果有40个 getWePkgAuthResult 失败，那它将会最多 增加到40 * 5 = 200
             * 次接口调用。先上线运营看看。
             */
            var getOneTimeWepkgAuthResult = function(){
                invoke('getWePkgAuthResult', {}, function(res) {
                    if(window.logInfo){
                        logInfo('getA8key',res,'get Login from getWePkgAuthResult');
                    }

                    var a8keyErrMsg = ('' + res.err_msg).replace(/[\s_]/g,'')
                                                        .toLowerCase();

                    var needWaitOnA8keyEvent = ( -1 != a8keyErrMsg.indexOf('notreturn')) ||
                                            ( -1 != a8keyErrMsg.indexOf('failfullurlempty'))
                    if(-1 != a8keyErrMsg.indexOf(':ok') ){
                        if(false === cbk.isCbkCalled){

                            saveLoginedA8key(res);
                            
                            cbk.isCbkCalled = true;
                            cbk && cbk(res, 'a8keygetWePkgAuthResult');
                        }
                    }else if( needWaitOnA8keyEvent ){

                        /**
                         * 如果是全平台下，not return ，则重试 5次，每次间隔500 ms
                         */
                        wepkgResultFailTimes++;
                        /**
                         * 如果尝试了小于5次，还失败。那就继续尝试。否则 不再尝试。
                         */
                        if(wepkgResultFailTimes <= 10){
                            if(window.logError){
                                logError(
                                    'getA8key',
                                    res,
                                    'trying ' + wepkgResultFailTimes
                                            + ' times getWePkgAuthResult'
                                );
                            }
                            setTimeout(getOneTimeWepkgAuthResult,500);
                            return;
                        } else {


                            var errmsg = 'try '
                                        + wepkgResultFailTimes
                                        + ' times getWePkgAuthResult Failed';

                            if(window.logError){
                                logError(
                                    'getA8key',res,
                                    errmsg,
                                    'I got no onGetA8KeyUrl Event, Page all crashed'
                                );
                            }

                            getA8keyInstance.EndLogic({
                                err_msg : errmsg
                            });

                            if(false === cbk.isCbkCalled){
                                cbk.isCbkCalled = true;
                                getPreLoginedA8key(getA8keyInstance,function(retry_res){
                                    if( false === retry_res){
                                        cbk && cbk({
                                            err_msg: errmsg
                                        }, 'wepkgToUrl');
                                    }else{
                                        cbk && cbk(retry_res, 'retryUseOldA8key');
                                    }
                                });
                                
                            }
                            return;
                        }
                    }else if( -1 != a8keyErrMsg.indexOf('offline')){
                        /**
                         * 如果是ios下，它返回了offline，就是在非wepkg下，
                         * 被强制调用了getWepkgAuthResult api（这其实是不允许的。）
                         * 出现这个的原因是为了兼容老版本。
                         */
                        if(false === cbk.isCbkCalled){
                            cbk.isCbkCalled = true;
                            cbk && cbk({
                                err_msg:'fail_offline'
                            }, 'wepkgOfflineToUrl');
                        }
                    }else{

                        getA8keyInstance.EndLogic({
                            err_msg :'unknow getA8key',
                            res     : res
                        });
                        if(false === cbk.isCbkCalled){
                            cbk.isCbkCalled = true;
                            cbk && cbk({
                                err_msg:'unknow getA8key'
                            }, 'unknow');
                        }
                    }
                });
            }
            getOneTimeWepkgAuthResult.call(win);
        }

        function getPreLoginedA8key(getA8keyInstance,cbk){
            /**记录有多少人调用了这个 获取旧的登陆态的逻辑。 */
            getA8keyInstance.EndLogic({
                err_msg:'getPreLoginedA8key'
            });
            invoke('getGameData',{
                key: A8KeyStoreKey
            },function(res){
                var err_msg = (res.err_msg || '').toLowerCase();

                /**如果 获取成功 */
                if( -1 != err_msg.indexOf(':ok')){
                    var ret = '';
                    
                    try {
                        //做一下兼容。因为没有value
                        ret = JSON.parse(res.value);
                    } catch (error) {
                        ret = {};
                    }               

                    cbk && cbk(ret);
                    getA8keyInstance.EndLogic({
                        err_msg:'getPreLoginedA8key_success'
                    });
                    
                }else{
                    cbk && cbk(false);
                    getA8keyInstance.EndLogic({
                        err_msg:'getPreLoginedA8key_fail_forjsapi'
                    });
                }
            });
        }
        function saveLoginedA8key(a8keyObj){
            invoke('setGameData',{
                key: A8KeyStoreKey,
                value: JSON.stringify(a8keyObj),
                expireTime: 60 * 60 * 24 * 15 //15天
            },function(res){
                var err_msg = (res.err_msg || '').toLowerCase();
                
                if( -1 == err_msg.indexOf(':ok')){
                    JsapiLog.logInfo('saveLoginedA8key_setGameData',res);
                }
            });
        }
        function invoke(act, opt, cbk) {

            getBridge(async function (_bridge) {

                /**
                 * 增加质量上报，一切jsapi
                 */
                var WXGAME      = win.WXGAME || {};
                var qualityBase = WXGAME.baseQualityReport || _qualityBase;
                var qa = qualityBase.StartLogic(
                    qualityBase.LOGIC_CONST.TypeTextEnum.JSAPI,
                    act,  // string
                    opt,  // json
                    null
                );
                // invoke之前做一些处理逻辑
                let result = await beforeInvoke(act, opt, cbk);
                if( result?.mock && result?.response ) {
                    qa.EndLogic(result.response);
                    cbk && cbk(result.response);
                    return 
                }
                // 客户端有日志【删除】
                // JsapiLog.logInfo('base_invoke',act);
                _bridge.invoke(act, opt, function(res){
                    if( act !== 'invokeMiniProgramAPI' ) {
                        /**
                         * 质量上报，jsapi出错后，才上报。 EndLogic里，会针对jsapi
                         * 做对应的  是否 出错判断
                         */
                        // 客户端有日志 + 点击流【删除】
                        // JsapiLog.logInfo(act,opt,res);
                        qa.EndLogic(res);
                    }
                    cbk && cbk(res);
                });
            });
        }

        function checkOnQuen(act, cbk) {
            if (!(act in _onList)) {
                _onList[act] = [];

                Dom.window.WeixinJSBridge.on(act, function (res) {
                    /**
                     * 增加质量上报，一切jsapi
                     */
                    var WXGAME      = win.WXGAME || {};
                    var onQuality = WXGAME.baseQualityReport || _qualityBase;
                    var qa = onQuality.StartLogic(
                        onQuality.LOGIC_CONST.TypeTextEnum.JSAPI,
                        act,  // string
                        {},  // json
                        null
                    );
                    JsapiLog.logInfo('base_jsapi_on',act);

                    
                    callOnQuen(act, res);

                    qa.EndLogic(res);
                });
            }

            for (var i = 0, il = _onList[act].length; i < il; i++) {
                if (cbk == _onList[act][i]) {
                    return;
                }
            }
            _onList[act].push(cbk);

        }

        function callOnQuen(act, res) {
            if (act in _onList) {
                for (var i = 0, il = _onList[act].length; i < il; i++) {
                    _onList[act][i](res);
                    _onList[act][i].called = true;
                }
            }
        }

        function funcOn(act, cbk) {
            if (!Dom.window.WeixinJSBridge) {
                getBridge(function () {
                    checkOnQuen(act, cbk);
                });
            } else {
                checkOnQuen(act, cbk);
            }
        }


        function isArray(o){
            return Object.prototype.toString.call(o) == '[object Array]';
        }

        /**
         *  一般用于隐藏菜单中不需要的选项，如分享到QQ、微博或者在safari中打开链接
         *  @static
         *  @function   filterOptionMenu
         *  @alias  jsbridge/jsbridge_base.filterOptionMenu
         */

        function init(opt, cbk) {
            opt = opt || {};
            verifyCall(apis, opt || {}, function (ret) {
                if (cbk && typeof (cbk) == 'function') {
                    cbk(ret);
                }
                if(opt && !opt.noHide){
                    invoke('hideMenuItems', {menuList:menuItems});
                }
            });
        }

        var ret;
        if ( win._wxBridge_base ) {
            ret = win._wxBridge_base;
        } else {
            ret = {
                apis             : apis,
                openTags         : openTags,
                menuItems        : menuItems,
                getBridge        : getBridge,
                verifyCall       : verifyCall,
                invoke           : invoke,
                call             : invoke,
                on               : funcOn,
                filterOptionMenu : init,
                getA8key         : getA8key
            };
        }

        win._wxBridge_base = ret;
        exportData = wxBridge || ret;

        //这里只是能window，传当前 的window
    })(window, window.document);

}else {
    exportData = {};
}
export default exportData;